export default __webpack_public_path__ + "static/media/step-4-profile.3b2f8083.svg";